import { Link, useLocation } from "react-router-dom"
import "../css/Header.css"
import { useEffect, useState } from "react";

const Header = () => {

    const location = useLocation();
    const [pathname, setPathname] = useState()

    useEffect(() => {
        setPathname(window.location.pathname)
    }, [location]);

    return (
        <header className="flex jcenter acenter header w100 gap-20 wrap pad-30"> {/* pad-10v */}

            <Link to="/">
                <img alt="logo" src="/images/LogoSpica.gif" className="h60px " />
            </Link>

            <nav className="flex gap-20 wrap jcenter header-nav">
                <Link to="/nosotros" className={(pathname == "/nosotros") ? "header-link-selected" : "header-link"}>Nosotros</Link>
                <Link to="/nuestros-servicios" className={(pathname == "/nuestros-servicios") ? "header-link-selected" : "header-link"}>Servicios</Link>
                <Link to="/partners-tecnologicos" className={(pathname == "/partners-tecnologicos") ? "header-link-selected" : "header-link"}>Partners</Link>
                <Link to="/proyectos" className={(pathname?.includes("/proyectos")) ? "header-link-selected" : "header-link"}>Proyectos</Link>
                <Link to="/seneca-video-actas" className={(pathname == "/seneca-video-actas") ? "header-link-selected" : "header-link"}>Tecnología Séneca</Link>
                <Link to="/contacto" className={(pathname == "/contacto") ? "header-link-selected" : "header-link"}>Contacto</Link>
            </nav>

            <Link to="/presupuesto" className="wine-button">Solicitar presupuesto</Link>

            <Link to="/igape" className="flex jcenter logo-ue">
                <img alt="logo ue" src="/images/UE.webp" className="h40px" />
            </Link>

        </header>
    )
}

export default Header
